import { HttpError } from '@/errors';
import type { ITransport } from '@/types';

/**
 * Sends event batches via HTTP POST.
 * Always available; used when the WebSocket is not open.
 */
export class RestTransport implements ITransport {
  readonly name = 'REST';

  constructor(
    private readonly apiUrl: string,
    private readonly apiKey: string,
    private readonly sessionId: string,
    private readonly csrfToken?: string
  ) {}

  isReady(): boolean {
    // REST is stateless — always ready as long as we have a sessionId.
    return this.sessionId.length > 0;
  }

  async send(events: unknown[]): Promise<void> {
    const res = await fetch(`${this.apiUrl}/api/sessions/${this.sessionId}/events`, {
      method: 'POST',
      headers: this.headers(),
      body: JSON.stringify({ events }),
    });

    if (!res.ok) {
      throw new HttpError(res.status, `[RestTransport] HTTP ${res.status} ${res.statusText}`);
    }
  }

  dispose(): void {
    // Nothing to tear down for a stateless HTTP transport.
  }

  private headers(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'x-api-key': this.apiKey,
    };
    if (this.csrfToken) {
      headers['x-csrf-token'] = this.csrfToken;
    }
    return headers;
  }
}
